// extracted by mini-css-extract-plugin
module.exports = {"margin-tag-label":"_1Cln5Rw2VQAtuM3BYbSfKH"};